import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Benefits.css';

const events = [
  {
    title: 'Психотерапевтические группы',
    text: 'Пространство для работы с внутренними конфликтами, отношениями и личными изменениями в поддерживающей группе.',
    link: '/benefits/grupp_psy',
    label: 'Для клиентов',
    image: '/images/IWF2.png',

    contacts: [
      {
        label: 'Фёдоров Игорь Валерьевич',
        href: 'https://t.me/Fedorov_App',
      },
      {
        label: '+7 (903) 955-33-96',
        href: 'tel:+79039553396',
      },
    ],
  },

  {
    title: 'Групповая психотерапия',
    text: 'Психодинамическая группа для исследования отношений, внутренних конфликтов и повторяющихся жизненных сценариев в безопасном пространстве.',
    label: 'Для клиентов',
    image: '/images/event-2.jpg',

    contacts: [
      {
        label: 'Беккер Светлана',
        href: 'https://t.me/lana_bekker',
      },
      {
        label: 'Барановский Олег',
        href: 'https://t.me/ohleg',
      },
    ],
  },

  {
    title: 'Кофе с психологом',
    text: 'Каждую субботу в кафе «Кафедра» (пр. Ленина, 79, 2 этаж) проходят открытые встречи с психологами Ассоциации. Все анонсы публикуем в Telegram и ВКонтакте.',
    label: 'События',
    image: '/images/event-4.jpg',

    contacts: [
      {
        label: 'Telegram',
        href: 'https://t.me/spp_psy_tomsk',
      },
      {
        label: 'ВКонтакте',
        href: 'https://vk.com/spp_psy_tomsk',
      },
    ],
  },

  {
    title: 'Скоро выйдет книга наших коллег',
    text: 'Мы рады поделиться важной новостью: коллеги из Ассоциации подготовили совместную книгу, в которой собрали профессиональный опыт, размышления и практический взгляд на психологию. Издание уже находится в печати — совсем скоро расскажем о нём подробнее.',
    label: 'Новость АПП',
    image: '/images/event-book.jpg',
  },
];

function Benefits() {
  const sliderRef = useRef(null);

  /* ========================================
     ПЕРЕХОД К КОНКРЕТНОМУ СЛАЙДУ
     ======================================== */

  const goToSlide = (index) => {
    const slider = sliderRef.current;

    if (!slider) return;

    slider.scrollTo({
      left: slider.clientWidth * index,
      behavior: 'smooth',
    });
  };

  /* ========================================
     СТРЕЛКИ
     ======================================== */

  const scrollSlider = (direction) => {
    const slider = sliderRef.current;

    if (!slider) return;

    const currentIndex = Math.round(
      slider.scrollLeft / slider.clientWidth
    );

    let nextIndex = currentIndex + direction;

    /* последний -> первый */
    if (nextIndex >= events.length) {
      nextIndex = 0;
    }

    /* первый -> последний */
    if (nextIndex < 0) {
      nextIndex = events.length - 1;
    }

    goToSlide(nextIndex);
  };

  /* ========================================
     АВТОМАТИЧЕСКОЕ ЛИСТАНИЕ
     ======================================== */

  useEffect(() => {
    const interval = setInterval(() => {
      const slider = sliderRef.current;

      if (!slider) return;

      const currentIndex = Math.round(
        slider.scrollLeft / slider.clientWidth
      );

      const nextIndex =
        currentIndex >= events.length - 1
          ? 0
          : currentIndex + 1;

      slider.scrollTo({
        left: slider.clientWidth * nextIndex,
        behavior: 'smooth',
      });
    }, 7000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="home-events">
      <div className="app-container">

        {/* ЗАГОЛОВОК */}
        <div className="home-events__heading">
          <h2>Новости и события Ассоциации</h2>

          <p>
            Обучение, профессиональные встречи, группы и события,
            которые проходят в АПП.
          </p>
        </div>

        {/* СЛАЙДЕР */}
        <div className="home-events-slider">

          <div
            className="home-events-slider__viewport"
            ref={sliderRef}
          >
            <div className="home-events-slider__track">

              {events.map((event) => (
                <article
                  className="home-events-slide"
                  key={event.title}
                >

                  {/* КАРТИНКА */}
                  <div className="home-events-slide__image">
                    <img
                      src={`${process.env.PUBLIC_URL}${event.image}`}
                      alt={event.title}
                    />
                  </div>

                  {/* ТЕКСТ */}
                  <div className="home-events-slide__content">

                    <span className="home-events-slide__label">
                      {event.label}
                    </span>

                    <h3>{event.title}</h3>

                    <p>{event.text}</p>

                    {/* КОНТАКТЫ */}
                    {event.contacts && (
                      <div className="home-events-slide__contacts">
                        {event.contacts.map((contact) => (
                          <a
                            key={contact.href}
                            href={contact.href}
                            target={
                              contact.href.startsWith('tel:')
                                ? undefined
                                : '_blank'
                            }
                            rel={
                              contact.href.startsWith('tel:')
                                ? undefined
                                : 'noopener noreferrer'
                            }
                          >
                            {contact.label}
                          </a>
                        ))}
                      </div>
                    )}

                    {/* ПОДРОБНЕЕ */}
                    {event.link && (
                      <Link
                        to={event.link}
                        className="home-events-slide__link"
                      >
                        Подробнее
                      </Link>
                    )}

                  </div>
                </article>
              ))}

            </div>
          </div>

          {/* СТРЕЛКИ */}
          <div className="home-events-slider__controls">

            <button
              type="button"
              onClick={() => scrollSlider(-1)}
              aria-label="Предыдущий слайд"
            >
              ←
            </button>

            <button
              type="button"
              onClick={() => scrollSlider(1)}
              aria-label="Следующий слайд"
            >
              →
            </button>

          </div>

        </div>

      </div>
    </section>
  );
}

export default Benefits;